import Link from 'next/link'
import React from 'react'
import { BreadcrumbInterface } from '../helper/PageInformationInterface'
// import useHeaderHeight from '../lib/useHeaderHeight'
import ChevronRight from '../public/icons/chevron-right.svg'
import Home from '/public/icons/home.svg'
import { useLoggedRouter } from '../helper/useLoggedRouter'
import TrendingTopics from './TrendingTopics'
import { getLinkObjectFromTeaser } from '../helper/link'

interface Data {
  breadcrumbs: BreadcrumbInterface[]
  navigate?: (id?: string, ressortId?: string, linkUrl?: string) => void
}

export default function Breadcrumbs(props: Data) {
  const [routerPush] = useLoggedRouter();
  const internalNavigate = async (e ,id, ressortId, linkUrl) => {
    e.stopPropagation();
    e.preventDefault();

    if (props.navigate) {
      props.navigate(id, ressortId, linkUrl)
    }
    else if(id) {
      await routerPush(`/article/${encodeURIComponent(id)}`);
    }
    else if(linkUrl) {
      await routerPush(linkUrl);
    }
    else if(ressortId) {
      await routerPush(`/ressort/${encodeURIComponent(ressortId)}`);
    }
    else if(id) {
      await routerPush(`/article/${encodeURIComponent(id)}`);
    }
  }

  return (<React.Fragment>
    {/* <div className="breadcrumbs" style={{ top: headerHeight + 'px' }}> */}
      {props && props.breadcrumbs && props.breadcrumbs.length > 0 &&
        <div className="breadcrumbs">
        { props.breadcrumbs.map(item => {
            const linkObject = getLinkObjectFromTeaser(item)
            if (item.showIcon || props.breadcrumbs.length == 1) {
              return (
                <React.Fragment key={`${item.id}`}>
                  <Link key={`link-${item.id}`} href="/" aria-label="Startseite">
                      <Home alt="Startseite" />
                  </Link>
                  <TrendingTopics teasers={item.trendingTopics}/>
                </React.Fragment>
              )
            }
            else if (linkObject.ressortId && linkObject.internalLink) {
              let linkUrl = linkObject.internalLink
              return (
                <React.Fragment key={`${linkObject.ressortId}`}>
                  <ChevronRight />
                  <Link key={`link-${linkObject.ressortId}`} href={linkUrl} className="breadcrumb-item" onClick={(e) => { internalNavigate(e, null, linkObject.ressortId, null) }}>
                    {/* <a key={`a-${item.id}`} className="breadcrumb-item"> */}
                      {item.name}
                    {/* </a> */}
                  </Link>
                </React.Fragment>
              )
            }
            else {
              return (
                <React.Fragment key={`${item.id}`}>
                  <ChevronRight />
                  <span className="breadcrumb-item">{item.name}</span>
                </React.Fragment>
              )
            }

          })
        }
        </div>
      }
    </React.Fragment>
  );
}